import { routesPermissions } from 'common/auth/permissions'
import LanguageRules from 'features/admin/language/rules'
import LanguageScore from 'features/admin/language/score'
import PersonalizationContentSwitch from 'features/admin/personalizedContent/PersonalizedContentSwitch'
import AdminRegionSettings from 'features/admin/regions/RegionSettings'
import AdminNodes from 'features/content/nodes'

import { TabbedNavRoute } from './interfaces'
import {
  languageRulesPath,
  languageScorePath,
  nodesPath,
  regionSettingsPath,
} from './paths'

export const regionSettingsRoute: TabbedNavRoute = {
  key: 'region',
  name: 'Region settings',
  to: regionSettingsPath,
  component: AdminRegionSettings,
  accessPermission: routesPermissions.contentView,
}

export const languageRulesRoute: TabbedNavRoute = {
  key: 'languageRules',
  name: 'Language rules',
  to: languageRulesPath,
  component: LanguageRules,
}

export const nodesRoute: TabbedNavRoute = {
  key: 'nodes',
  name: 'Nodes',
  to: nodesPath,
  component: AdminNodes,
}
export const personalizationContentRoute: TabbedNavRoute = {
  key: 'personalizedContent',
  name: 'Personalised Content',
  to: '/admin/language/personalized-content',
  component: PersonalizationContentSwitch,
  accessFlags: { flags: ['showLanguagePersonalizedContent'], type: 'hide' },
  accessPermission: routesPermissions.personalizedContentView,
}

export const languageScoreRoute: TabbedNavRoute = {
  key: 'languageScore',
  name: 'Score',
  to: languageScorePath,
  component: LanguageScore,
  accessFlags: { flags: ['qualityScore'], type: 'hide' },
}

export const languageSubroutes: TabbedNavRoute[] = [
  nodesRoute,
  languageRulesRoute,
  languageScoreRoute,
  regionSettingsRoute,
  personalizationContentRoute,
]
